/**
 * A GraphQL `User` from inventory-api.
 *
 * The camelCase matters: rest-schema.graphql declares a *different* `User` for
 * the es-api REST endpoints, with snake_case fields, and codegen merges the two
 * so both spellings typecheck. Only the live server tells them apart.
 */
type NamedUser = {
	firstName?: string | null,
	lastName?: string | null,
}

/**
 * How a picker is named on screen. Null when there is nobody to name, so the
 * caller decides what "nobody" reads as in its own context — "Unassigned" in a
 * list, an empty field in a form.
 */
export function userDisplayName( user?: NamedUser | null ): string | null {
	if ( !user ) {
		return null
	}
	const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
	return name || null
}

export default userDisplayName
